module.exports = require('../../full/object/keys');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/features/object/keys.js
// module id = l8ZG
// module chunks = 0